export default "__VITE_ASSET__D$EUz5Nk__"